<template>
  <div v-loading="loading">
    <div class="search">
      <el-form class="searchform" ref="form" :model="searchform" label-width="80px" label-position="left">
        <el-form-item label="快速搜索">
          <el-input @input="getdata" placeholder="請輸電話號碼或網絡提供商......" v-model="searchform.keyword" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <!-- <el-button @click="getdata" slot="append" icon="el-icon-search"></el-button> -->
          </el-input>
        </el-form-item>
      </el-form>

    </div>
    <div class="pagemain">
      <div class="pagetablebox">
        <el-table empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">
          <el-table-column width="200" prop="code" label="代號" align="center">
						<template slot-scope="scope">
							<div class="phonecel">代號</div>
							<div>{{scope.row.code}}</div>
						</template>
					</el-table-column>
          <el-table-column prop="phone" label="電話號碼" align="center">
            <template slot-scope="scope">
              <div class="phonecel">電話號碼</div>
              <div>{{scope.row.phone}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="service" label="網絡提供商" align="center">
            <template slot-scope="scope">
              <div class="phonecel">網絡提供商</div>
              <div>{{scope.row.service}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="cardnum" label="關聯卡數" align="center">
            <template slot-scope="scope">
              <div class="phonecel">關聯卡數</div>
              <div>{{scope.row.cardnum}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="餘額" align="center">
            <template slot-scope="scope">
              <div class="phonecel">餘額</div>
              <div>{{scope.row.money}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="endtime" label="到期日期" align="center">
            <template slot-scope="scope">
              <div class="phonecel">到期日期</div>
              <div>{{scope.row.endtime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="備註" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">備註</div>
              <span>{{scope.row.remarks}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="phonecel">操作</div>
              <el-button size="mini" @click="choose(scope.row)">導入</el-button>
            </template>

          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px">

      </div>
      <div class="page-bottom" style="margin-top:15px;">
        <div>
          Total: {{pager.p_count}}個賬號

        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "chooseholder",

  data () {
    return {
      loading: false,
      data: [],
      searchform: {},
      mso_id: 0,
      page: 1,
      pagesize: 10,
      pager: [],
    }
  },

  methods: {
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    choose (row) {

      this.$emit('closephone', row);
    },

    getdata () {
      this.post('/api/bank/bank_phone', {
        mso_id: this.mso_id,
        pagesize: this.pagesize,
        page: this.page,
        keyword: this.searchform.keyword
      }).then((res) => {
        this.data = res.info;
        this.pager = res.pager;
        this.page = 1;
      }).catch((err) => {

        console.log(err)
      })
    },
  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    this.getdata();
  }




}
</script>

<style>
</style>